import {Fit, Layout, Rive, RiveFile} from "@rive-app/canvas";

const favoriteRiveInstances = [];

export const cleanupFavoriteRive = () => {
    favoriteRiveInstances.forEach((riveInstance) => {
        riveInstance.cleanup();
    })
}

export const initializeFavoriteRive = () => {
    //before initializing let's cleanup all favorite instances.
    const favoriteButtons = document.querySelectorAll('.btn.favorite');

    if (!favoriteButtons) {
        return;
    }

    const initFavoriteRiveInstances = (file) => {

        favoriteButtons.forEach((button) => {

            const heartCanvas = button.querySelector('.heart-canvas');

            const isInitalFavorited = heartCanvas.dataset.active === 'true';
            const favoriteId = heartCanvas.dataset.favoriteId;
            const isEnabled = heartCanvas.dataset.enabled === 'true';

            let changeStateInput = null

            const rive = new Rive({
                riveFile: file,
                canvas: heartCanvas,
                stateMachines: ['HeartStateMachine'],
                autoplay: true,
                layout: new Layout({
                    fit: Fit.Cover,
                }),
                onLoad: () => {
                    computeSize()

                    const inputs = rive.stateMachineInputs('HeartStateMachine');
                    /**
                     * States values
                     * 1 - Outlined
                     * 2 - Filled
                     * 3 - Unfavorite
                     * 4 - Favorite
                     */
                    changeStateInput = inputs.find(i => i.name === 'ChangeState');

                    changeStateInput.value = isInitalFavorited ? 2 : 1;
                }
            });

            function computeSize() {
                rive.resizeDrawingSurfaceToCanvas();
            }

            // Subscribe to window size changes and update call `resizeDrawingSurfaceToCanvas`
            window.onresize = computeSize;
            // Subscribe to devicePixelRatio changes and call `resizeDrawingSurfaceToCanvas`
            window
                .matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`)
                .addEventListener("change", computeSize);

            favoriteRiveInstances.push(rive)

            const handleFavoriteTimes = (addTimes) => {
                const counterElement = button.querySelector('.favorited-count')
                let countValue = parseInt(counterElement.innerHTML)

                if (addTimes) {
                    heartCanvas.dataset.active = "true"
                    countValue++;

                    counterElement.classList.remove('d-none')
                    counterElement.innerText = countValue.toString();
                } else {
                    heartCanvas.dataset.active = "false"
                    countValue--;

                    if (countValue === 0) {
                        counterElement.classList.add('d-none')
                    }
                    counterElement.innerText = countValue.toString();
                }
            }

            const favoriteAction = () => {
                handleFavoriteTimes(true);
                button.disabled = true;

                fetch(`/website-api/favorites/${favoriteId}/`, {
                    credentials: "same-origin",
                    method: "post",
                })
                    .then((response) => response.json())
                    .then(function () {
                        button.disabled = false;
                    })
            }

            const unFavoriteAction = () => {
                handleFavoriteTimes(false);
                button.disabled = true;

                fetch(`/website-api/user/favorite/${favoriteId}/`, {
                    credentials: "same-origin",
                    method: "delete",
                })
                    .then((response) => response.json())
                    .then(function () {
                        button.disabled = false;
                    })
            }

            button.addEventListener('click', (e) => {
                if (isEnabled) {
                    const isFavorited = heartCanvas.dataset.active === 'true';

                    if (isFavorited) {
                        changeStateInput.value = 3;
                        unFavoriteAction()
                    } else {
                        changeStateInput.value = 4;
                        favoriteAction()
                    }
                }
            })
        })
    }

    const loadAndCacheRiveFile = (src, onSuccess, onError)  =>{
        const file = new RiveFile({
            src: src,
            onLoad: () => onSuccess(file),
            onLoadError: onError,
        });
        //Trigger the load
        file.init().catch(onError);
    }

    loadAndCacheRiveFile(
        '/inc/assets/images/rive/heart_animation.riv',
        (file) => {
            initFavoriteRiveInstances(file)
        },
        (error) => {
            console.error("Failed to load Rive file:", error);
        }
    )
}
